import { createClient } from '@supabase/supabase-js';

// Create React App inlines ONLY variables prefixed REACT_APP_ at build time.
// Everything else in process.env compiles away to undefined.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// THERE IS NO "IS THIS THE REAL PROJECT" CHECK HERE, AND THERE MUST NOT BE ONE.
//
// The consumer-facing site once treated one specific project URL as "not
// configured", reasoning that a stale scaffolding default should not be able to
// masquerade as a working backend. That URL was the live production project, so
// the guard did the exact thing it was written to prevent, in reverse: it
// reported a correctly configured backend as unconfigured and refused every
// sign-in before a request left the browser. Every test passed, because the
// tests asserted the sentinel behaved as designed, and it did.
//
// A hard-coded guess about which external resource is "the real one" cannot be
// verified from inside this repository, and when it drifts it fails closed and
// looks like an outage somewhere else. If a URL is wrong, the request to it
// fails and says so in the server's own words.
export function supabaseConfigStatus() {
  if (!supabaseUrl) {
    return {
      ok: false,
      reason: 'missing-url',
      detail: 'REACT_APP_SUPABASE_URL was not set when this portal was built.',
    };
  }
  if (!supabaseAnonKey) {
    return {
      ok: false,
      reason: 'missing-key',
      detail: 'REACT_APP_SUPABASE_ANON_KEY was not set when this portal was built.',
    };
  }
  return { ok: true, reason: null, detail: null };
}

export const isSupabaseConfigured = () => supabaseConfigStatus().ok;

// createClient() THROWS on a missing url or key, at module load, before React
// renders anything — a blank screen with the reason visible only in a console
// nobody has open. These fallbacks are inert on purpose: syntactically valid,
// resolving to nothing, so the module loads and supabaseConfigStatus() can say
// no in words.
export const supabase = createClient(
  supabaseUrl || 'http://127.0.0.1:54321',
  supabaseAnonKey || 'not-configured',
  {
    auth: {
      // Staff identity is a separate system from user identity (canon 1.2), and
      // that separation is worth nothing if the two share a storage key on a
      // laptop where somebody is also a landlord using their own platform. A
      // distinct key means a staff session and a consumer session can coexist
      // in one browser without either being able to see or overwrite the other.
      storageKey: 'orchid.staff.auth',
    },
  }
);
